class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    
    // Reset error state when closing
    this.hideError();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // Hide error and show success content
    this.hideError();
    this.showSuccessContent();

    if (this.header) this.header.reveal();
    this.open();
  }

  renderError(errorMessage) {
    const errorContainer = document.getElementById('cart-notification-error');
    const productContainer = document.getElementById('cart-notification-product');
    const linksContainer = this.notification.querySelector('.cart-notification__links');
    const heading = this.notification.querySelector('.cart-notification__heading');
    
    if (errorContainer) {
      errorContainer.textContent = errorMessage || 'This product is no longer available in the requested quantity.';
      errorContainer.style.display = 'block';
    }
    
    // Hide product info and checkout buttons on error
    if (productContainer) productContainer.style.display = 'none';
    if (linksContainer) linksContainer.style.display = 'none';
    
    // Change heading to error
    if (heading) {
      heading.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #c00;">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span style="color: #c00; margin-left: 8px;">Not available</span>
      `;
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  hideError() {
    const errorContainer = document.getElementById('cart-notification-error');
    if (errorContainer) {
      errorContainer.style.display = 'none';
      errorContainer.textContent = '';
    }
  }

  showSuccessContent() {
    const productContainer = document.getElementById('cart-notification-product');
    const linksContainer = this.notification.querySelector('.cart-notification__links');
    const heading = this.notification.querySelector('.cart-notification__heading');
    
    if (productContainer) productContainer.style.display = '';
    if (linksContainer) linksContainer.style.display = '';
    
    // Reset heading to success
    if (heading) {
      heading.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        Item added to your cart
      `;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

document.addEventListener('DOMContentLoaded', () => {
  const cartNotification = document.querySelector('cart-notification');
  const header = document.querySelector('sticky-header');

  if (cartNotification && header) {
    const headerHeight = header.offsetHeight;

    // patch de open functie van CartNotification
    const originalOpen = cartNotification.open;
    cartNotification.open = function () {
      originalOpen.call(this);
      this.notification.style.top = (headerHeight + 60) + 'px';
    };
  }
});
